import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(onboarding)/(auth)')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <div className="mx-auto w-full max-w-md">
            <Outlet />
        </div>
    )
}
